// AUTO-GENERATED — DO NOT EDIT BY HAND.
//
// Source: https://github.com/wwahmed/waki-shell/blob/main/src/config/hostnames.ts
// Sync:   scripts/sync-hostnames.sh
//
// Edit the registry in waki-shell, then run scripts/sync-hostnames.sh
// in every consumer (brain-v2, WakiOutlookViewer). See
// docs/architecture/hostname-registry.md for the full design.

export type AppKind = "memso" | "mail";
export type Brand = "memso.ai" | "3dbypixel.com";

export interface HostnameEntry {
  hostname: string;
  app: AppKind;
  brand: Brand | null;
  counterpartHostname: string | null;
  cloudflarePagesProject: string | null;
  origin: string;
  cookieDomain: string | null;
}

interface HostnamesPayload {
  version: string;
  schema: 1;
  hostnames: HostnameEntry[];
  devHostnames: HostnameEntry[];
  internalHostnames: string[];
}

const DATA: HostnamesPayload = {
  "version": "0.3.0",
  "schema": 1,
  "hostnames": [
    {
      "hostname": "app.memso.ai",
      "app": "memso",
      "brand": "memso.ai",
      "counterpartHostname": "mail.memso.ai",
      "cloudflarePagesProject": "memso-app",
      "origin": "https://app.memso.ai",
      "cookieDomain": ".memso.ai"
    },
    {
      "hostname": "mail.memso.ai",
      "app": "mail",
      "brand": "memso.ai",
      "counterpartHostname": "app.memso.ai",
      "cloudflarePagesProject": "wakioutlookviewer",
      "origin": "https://mail.memso.ai",
      "cookieDomain": ".memso.ai"
    },
    {
      "hostname": "app.3dbypixel.com",
      "app": "memso",
      "brand": "3dbypixel.com",
      "counterpartHostname": "mail.3dbypixel.com",
      "cloudflarePagesProject": "memso-app",
      "origin": "https://app.3dbypixel.com",
      "cookieDomain": ".3dbypixel.com"
    },
    {
      "hostname": "mail.3dbypixel.com",
      "app": "mail",
      "brand": "3dbypixel.com",
      "counterpartHostname": "app.3dbypixel.com",
      "cloudflarePagesProject": "wakioutlookviewer",
      "origin": "https://mail.3dbypixel.com",
      "cookieDomain": ".3dbypixel.com"
    }
  ],
  "devHostnames": [
    {
      "hostname": "localhost:5173",
      "app": "memso",
      "brand": null,
      "counterpartHostname": "localhost:5174",
      "cloudflarePagesProject": null,
      "origin": "http://localhost:5173",
      "cookieDomain": null
    },
    {
      "hostname": "localhost:5174",
      "app": "mail",
      "brand": null,
      "counterpartHostname": "localhost:5173",
      "cloudflarePagesProject": null,
      "origin": "http://localhost:5174",
      "cookieDomain": null
    },
    {
      "hostname": "localhost:8190",
      "app": "memso",
      "brand": null,
      "counterpartHostname": "localhost:8290",
      "cloudflarePagesProject": null,
      "origin": "http://localhost:8190",
      "cookieDomain": null
    },
    {
      "hostname": "localhost:8290",
      "app": "mail",
      "brand": null,
      "counterpartHostname": "localhost:8190",
      "cloudflarePagesProject": null,
      "origin": "http://localhost:8290",
      "cookieDomain": null
    },
    {
      "hostname": "localhost:3000",
      "app": "memso",
      "brand": null,
      "counterpartHostname": null,
      "cloudflarePagesProject": null,
      "origin": "http://localhost:3000",
      "cookieDomain": null
    }
  ],
  "internalHostnames": [
    "brain2.3dbypixel.com",
    "waqas.memso.ai",
    "wov.3dbypixel.com"
  ]
};

export const HOSTNAMES: readonly HostnameEntry[] = DATA.hostnames;
export const DEV_HOSTNAMES: readonly HostnameEntry[] = DATA.devHostnames;
export const INTERNAL_HOSTNAMES: readonly string[] = DATA.internalHostnames;
export const ALL_HOSTNAMES: readonly HostnameEntry[] = [...HOSTNAMES, ...DEV_HOSTNAMES];
export const REGISTRY_VERSION: string = DATA.version;

export function findHostnameEntry(host: string): HostnameEntry | undefined {
  if (!host) return undefined;
  const h = host.toLowerCase();
  return ALL_HOSTNAMES.find((e) => e.hostname === h);
}

export function findProdHostnameEntry(host: string): HostnameEntry | undefined {
  if (!host) return undefined;
  const h = host.toLowerCase();
  return HOSTNAMES.find((e) => e.hostname === h);
}

export function knownHostsSet(): Set<string> {
  const s = new Set<string>();
  for (const e of ALL_HOSTNAMES) s.add(e.hostname);
  for (const h of INTERNAL_HOSTNAMES) s.add(h);
  return s;
}

export function hostnamesForApp(app: AppKind): HostnameEntry[] {
  return ALL_HOSTNAMES.filter((e) => e.app === app);
}

export function hostnamesForPagesProject(project: string): HostnameEntry[] {
  return HOSTNAMES.filter((e) => e.cloudflarePagesProject === project);
}

export function allPagesProjects(): string[] {
  const s = new Set<string>();
  for (const e of HOSTNAMES) {
    if (e.cloudflarePagesProject) s.add(e.cloudflarePagesProject);
  }
  return [...s].sort();
}

export function sessionCookieNameForBrand(brand: Brand): string {
  return brand === "memso.ai" ? "memso_session" : "memso_session_3dbp";
}

export interface CounterpartResolution {
  currentApp: AppKind;
  counterpartApp: AppKind;
  counterpartHostname: string;
  counterpartUrl: string;
}

export function getCounterpartUrl(host: string): CounterpartResolution | null {
  const entry = findHostnameEntry(host);
  if (!entry || !entry.counterpartHostname) return null;
  const sib = findHostnameEntry(entry.counterpartHostname);
  if (!sib) return null;
  return {
    currentApp: entry.app,
    counterpartApp: sib.app,
    counterpartHostname: sib.hostname,
    counterpartUrl: sib.origin.endsWith("/") ? sib.origin : `${sib.origin}/`,
  };
}

export function getCounterpartLabel(host: string): string | null {
  const r = getCounterpartUrl(host);
  if (!r) return null;
  return r.counterpartApp === "memso" ? "Open Memso" : "Open Mail";
}

export function appIdentityMarker(app: AppKind): string {
  return app;
}
